export default {
  title: 'Buscador'
}
